import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Docs from './pages/Docs';
import GettingStarted from './pages/GettingStarted';
import Home from './pages/Home';
import Install from './pages/Install';
import Privacy from './pages/Privacy';
import Settings from './pages/Settings';
import Support from './pages/Support';
import Terms from './pages/Terms';
import TimeMachineTest from './pages/TimeMachineTest';

export default function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/install" element={<Install />} />
          <Route path="/getting-started" element={<GettingStarted />} />
          <Route path="/docs" element={<Docs />} />
          <Route path="/support" element={<Support />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms-conditions" element={<Terms />} />
          <Route path="/time-machine" element={<TimeMachineTest />} />
        </Routes>
      </Layout>
    </Router>
  );
}
